import './Article.css'

export default function Article(props)
{
    return (
        <div className='article-wrapper' onClick={() => { props.setArticleOpen(false) }}>
            <div className='article-centered'>
                <div className='article-close-button-wrapper'>
                    <button className='article-close-button' onClick={() => { props.setArticleOpen(false) }}></button>
                </div>
                <div className='article-pill-wrapper'>
                    <div className='article-pill' />
                </div>
                <div className='article-content-wrapper'>
                    <h1 className='article-headline'><a onClick={(e) => { e.stopPropagation() }} href={props.article.link} target="_blank"><span>{props.article.title}</span></a></h1>
                    <img alt={""} className="article-image" src={require('../images/' + props.article.image)} />
                    <p className='article-caption'>{props.article.caption}</p>
                </div>
            </div>
        </div>
    )
}